import { render, staticRenderFns } from "./Ctfb.vue?vue&type=template&id=979b1b98"
import script from "./Ctfb.vue?vue&type=script&lang=js"
export * from "./Ctfb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports